import {stickyElement} from "./utilities/sticky";

export function stickyHeader(headerArea = document.querySelector('.headerMain')) {
    if (headerArea) {
        stickyElement(headerArea, true);
    }
}